export class DirectDebitEntity {
  constructor() {
    this.id = null;
    this.fromAccountName = null;
    this.fromAccountId = null;
    this.toAccountName = null;
    this.reference = null;
    this.payType = null;
    this.category = null;
    this.accountNumber = null;
    this.type = null;
    this.amount = null;
    this.when = null;
    this.paymentType = 'Direct Debit';
  }
  getDirectDebit() {
    return this;
  }
  getDirectDebitId() {
    return this.id;
  }
  setDirectDebitId(accountId) {
    this.id = accountId;
  }
}
export default DirectDebitEntity;
